declare var $: any;

export default class UmbracoForm {
	private form: HTMLFormElement;
	constructor(umbracoForm: HTMLFormElement) {
		this.form = umbracoForm;
		if (!this.form) {
			return;
		}
		this.prevalidateForm();
		this.scrollSuccessMessageIntoView();
		this.scrollErrorMessagesIntoView();
	}

	private prevalidateForm() {
		if (this.form.classList.contains("js-prevalidate-form")) {
			window.onload = () => {
				$(this.form).valid();
			}
		}
	}

	private scrollSuccessMessageIntoView() {
		const umbracoFormSuccessMessage = this.form.querySelector('.js-umbraco-form-success-message');
		if (umbracoFormSuccessMessage) {
			umbracoFormSuccessMessage.scrollIntoView();
		}
	}

	private scrollErrorMessagesIntoView() {
		const umbracoFormErrorMessages = this.form.querySelector('.js-umbraco-form-error-messages');
		if (umbracoFormErrorMessages) {
			umbracoFormErrorMessages.scrollIntoView();
		}
	}
}
